// import Cookies from 'js-cookie';
import { getLocalStorage, setLocalStorage } from '@/utils/index';

export function getToken() {
  const token = {
    'token': getLocalStorage('token'),
    'seed': getLocalStorage('seed'),
    // 'app_id': Cookies.get('app_id'),
    // 'device_id': Cookies.get('device_id')
  };
  return token;
}

export function setToken(token) {
  setLocalStorage('token', token.token);
  setLocalStorage('seed', token.seed);
  // Cookies.set('app_id', token.app_id);
  // Cookies.set('device_id', token.device_id);
}

export function removeToken() {
  setLocalStorage('token', '');
  setLocalStorage('seed', '');
  // Cookies.remove('app_id');
  // Cookies.remove('device_id');
}
